import React from "react";
import Badge from "./Badge";
import H5 from "./Typography/H5";
import H4 from "./Typography/H4";
import { normalizeImageUrl } from "../utils/url";

interface BasicCardProps {
  props?: any;
}

export const BasicCard: React.FC<BasicCardProps> = (props: any) => {
  console.log("data 1", props);
  const {
    ticker_symbol,
    company_name,
    currency,
    closed,
    market_name,
    falcon_fiscal_year,
    falcon_latest_quarter_date,
    falcon_latest_quarter_label,
  } = props;
  return (
    <div className="bg-white rounded-lg shadow-md p-4">
      <div className="flex items-center">
        <H4 className="mr-2">{company_name}</H4>
        {ticker_symbol && (
          <Badge status="success" small>
            {ticker_symbol}
          </Badge>
        )}
        {falcon_fiscal_year ? (
          <span className="ml-2 inline-flex items-center rounded-full bg-blue-50 px-2 py-1 text-xs font-semibold text-blue-700">
            Falcon
          </span>
        ) : null}
      </div>
      <div className="flex mt-2 items-center">
        <H5 className="mr-4">
          {closed} {currency}
        </H5>
        <p className="mr-4">{market_name}</p>
      </div>
      {falcon_fiscal_year ? (
        <div className="mt-3 rounded-md border border-blue-100 bg-blue-50 px-3 py-2 text-sm text-blue-800">
          <div className="font-semibold">Latest finalized Falcon review</div>
          <div>
            FY {falcon_fiscal_year}
            {falcon_latest_quarter_date
              ? ` | ${falcon_latest_quarter_date}`
              : ""}
          </div>
          {falcon_latest_quarter_label ? (
            <div className="text-xs text-blue-700">
              {falcon_latest_quarter_label}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

interface FeaturedCardProps {
  title: string;
  description: string;
  imageUrl?: string;
  ticker_symbol?: string;
}

export const FeaturedCard: React.FC<FeaturedCardProps> = ({
  title,
  description,
  imageUrl,
  ticker_symbol,
}) => {
  const normalizedImageUrl = normalizeImageUrl(imageUrl);

  return (
    <div className="flex bg-white rounded-lg shadow-md overflow-hidden mt-4">
      {normalizedImageUrl && (
        <img
          src={normalizedImageUrl}
          alt={title}
          className="w-36 object-contain pt-2 px-2"
        />
      )}
      <div className="p-4">
        <h2 className="text-lg mb-2">
          {title}
          {ticker_symbol && (
            <span className="ml-3">
              <Badge status="success">{ticker_symbol}</Badge>
            </span>
          )}
        </h2>
        <p>{description}</p>
      </div>
    </div>
  );
};
